"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseModalButton = exports.StyledModal = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const antd_1 = require("antd");
const styled_breakpoints_1 = require("styled-breakpoints");
exports.StyledModal = (0, styled_components_1.default)(antd_1.Modal) `
	top: 0;
	width: 100vw !important;
	height: 100vh;
	max-width: none;
	padding: 0;
	margin: 0;
`;
exports.CloseModalButton = styled_components_1.default.div `
	position: absolute;
	right: 1rem;
	top: 1rem;
	background-color: ${props => props.theme.color.gray2};
	width: 3rem;
	height: 3rem;
	border-radius: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1.5rem;
	cursor: pointer;
	pointer-events: auto;
	z-index: 1001;
	${(0, styled_breakpoints_1.down)('sm')} {
		font-size: 1rem;
		width: 2rem;
		height: 2rem;
	}
`;
